import tippy from 'tippy.js/headless';
import debounce from 'lodash/debounce';
import domReady from '../helpers/dom-ready';

class Menu {
  static init() {
    return new Menu();
  }

  constructor() {
    this.menu = document.querySelector('.brix-menu');
    this.main = document.querySelector('main');

    this.isMenuOpen = false;
    this.isMenuClosing = false;
    this.isSearchOpen = false;

    this.setUpMenus();
    this.setupPopperPlugin();
    this.setupLanguageSwitcher();
    this.setupSearch();
    // this.getOverlappingBlock();
  }

  // getOverlappingBlock() {
  //   const blocks = document.querySelectorAll('.brix-block');

  //   window.addEventListener('scroll', () => {
  //     const hamburgerButtonRect = this.hamburgerButton.getBoundingClientRect();
  //     [...blocks].forEach((block) => {
  //       const blockRect = block.getBoundingClientRect();
  //       if (blockRect.top <= hamburgerButtonRect.top + hamburgerButtonRect.height
  //         && blockRect.top + blockRect.height > hamburgerButtonRect.top
  //       ) {
  //         if (block.classList.contains('brix-rich-text')) {
  //           this.hamburgerButton.style.backgroundColor = '#111';
  //           this.hamburgerButton.style.color = '#eea499';
  //         }
  //       }
  //     });
  //   });
  // }

  setUpMenus() {
    this.hamburgerButton = this.menu.querySelector('.menu-button');
    this.menuWrapper = this.menu.querySelector('.menu-wrapper');
    this.primaryMenu = this.menu.querySelector('.primary-menu');
    const topMenuItems = this.menu.querySelectorAll('.top-menu-item.-has-sub-menu');

    this.initialHamburgerButtonColor = getComputedStyle(this.hamburgerButton).color;
    this.initialPrimaryMenuBackgroundColor = getComputedStyle(this.primaryMenu).backgroundColor;

    this.toggleScrolled();

    window.addEventListener('scroll', debounce(() => {
      this.toggleScrolled();
    }), 100);

    this.hamburgerButton.addEventListener('click', () => {
      if (this.isSearchOpen) {
        this.closeSearch();
      } else if (this.isMenuOpen) {
        this.closeMenu();
      } else {
        this.openMenu();
      }
    });

    this.menuWrapper.addEventListener('click', (e) => {
      if (this.isMenuOpen) {
        if (e.target !== e.currentTarget) return;
        this.closeMenu();
      }
    });

    this.primaryMenu.addEventListener('transitionend', () => {
      if (!this.isMenuOpen) {
        this.closeSubMenus();
      }
    });

    this.hamburgerButton.addEventListener('animationend', () => {
      if (this.isMenuClosing) {
        this.hamburgerButton.classList.remove('-closing');
        this.isMenuClosing = false;
      }
    });

    const primaryMenuItems = this.menu.querySelectorAll('.primary-menu-item');
    const secondaryMenuItems = this.menu.querySelectorAll('.secondary-menu-item');
    const backButtons = this.menu.querySelectorAll('.back-button');
    this.subMenus = this.menu.querySelectorAll('.sub-menu');

    [...primaryMenuItems, ...secondaryMenuItems].forEach((menuItem) => {
      menuItem.addEventListener('mouseenter', (e) => {
        const selectedItemBackgroundColor = e.target.dataset.postColor;
        this.primaryMenu.style.backgroundColor = selectedItemBackgroundColor;
        this.hamburgerButton.style.color = selectedItemBackgroundColor;

        [...primaryMenuItems, ...secondaryMenuItems].forEach((menuItem2) => {
          if (menuItem2 !== e.target) {
            menuItem2.style.opacity = 0.5; // eslint-disable-line no-param-reassign
          }
        });
      });

      menuItem.addEventListener('mouseout', () => {
        this.primaryMenu.style.backgroundColor = this.initialPrimaryMenuBackgroundColor;
        this.hamburgerButton.style.color = this.initialPrimaryMenuBackgroundColor;

        [...primaryMenuItems, ...secondaryMenuItems].forEach((menuItem2) => {
          menuItem2.style.opacity = 1; // eslint-disable-line no-param-reassign
        });
      });
    });

    [...primaryMenuItems].forEach((button) => {
      button.addEventListener('click', () => {
        const { id } = button.dataset;
        const subMenu = document.querySelector(`.sub-menu[data-id='${id}']`);
        subMenu.classList.add('-open');
        this.primaryMenu.classList.add('-no-scroll');
      });
    });

    [...backButtons].forEach((button) => {
      button.addEventListener('click', () => {
        [...this.subMenus].forEach((subMenu) => {
          subMenu.classList.remove('-open');
          this.primaryMenu.classList.remove('-no-scroll');
        });
      });
    });

    [...topMenuItems].forEach((menuItem) => {
      menuItem.addEventListener('click', () => {
        const { id } = menuItem.dataset;
        const subMenu = document.querySelector(`.sub-menu[data-id='${id}']`);
        subMenu.classList.add('-open');
        this.openMenu();
      });
    });
  }

  openMenu() {
    this.hamburgerButton.classList.add('-open');
    this.menuWrapper.classList.add('-open');
    this.disableBodyScroll();
    this.isMenuOpen = true;
    this.hamburgerButton.style.color = this.initialPrimaryMenuBackgroundColor;
  }

  closeSubMenus() {
    [...this.subMenus].forEach((subMenu) => {
      subMenu.classList.remove('-open');
    });
  }

  closeMenu() {
    this.isMenuClosing = true;
    this.hamburgerButton.classList.remove('-open');
    this.menuWrapper.classList.remove('-open');
    this.hamburgerButton.classList.add('-closing');
    this.isMenuOpen = false;
    this.enableBodyScroll();
    this.hamburgerButton.style.color = this.initialHamburgerButtonColor;
  }

  toggleScrolled() {
    if (window.scrollY > 8) {
      this.menu.classList.add('-scrolled');
    } else {
      this.menu.classList.remove('-scrolled');
    }
  }

  openSearch() {
    this.menu.classList.add('-search-open');
    this.searchWrapper.classList.remove('-closed');
    this.searchWrapper.classList.add('-open');
    if (window.innerWidth < 1025) { // $sceeen-lg: 1024px
      this.hamburgerButton.classList.remove('-open');
    }
    this.disableBodyScroll();
    this.isSearchOpen = true;
    this.searchInput.focus();
  }

  closeSearch() {
    this.searchInput.value = '';
    this.searchGoIcon.classList.remove('-hidden');
    this.searchClearButton.classList.add('-hidden');

    this.menu.classList.remove('-search-open');
    this.searchWrapper.classList.remove('-is-closing');
    this.searchWrapper.classList.add('-closed');
    if (window.innerWidth < 1025) { // $sceeen-lg: 1024px
      this.hamburgerButton.classList.add('-open');
    }
    this.enableBodyScroll();
    this.isSearchOpen = false;
    this.searchInput.blur();
  }

  setupSearch() {
    this.searchWrapper = this.menu.querySelector('.search-wrapper');
    const openSearchButtons = this.menu.querySelectorAll('.open-search-button');
    const closeSearchButton = this.menu.querySelector('.close-search-button');
    const searchForm = this.menu.querySelector('.search-form');
    const searchInputWrapper = searchForm.querySelector('.search-input-wrapper');
    this.searchInput = searchInputWrapper.querySelector('.search-input');
    this.searchGoIcon = searchInputWrapper.querySelector('.search-go-icon');
    this.searchClearButton = searchInputWrapper.querySelector('.search-clear-button');
    const searchCancelButton = searchForm.querySelector('.search-cancel-button');

    const runSearch = () => {
      if (this.searchInput.value === '') {
        this.searchInput.focus();
      } else {
        const { searchUrl } = searchForm.dataset;
        const searchQuery = encodeURIComponent(this.searchInput.value).replace(/%20/g, '+');

        window.location.href = `${searchUrl}?search=${searchQuery}`;
      }
    };

    [...openSearchButtons].forEach((button) => {
      button.addEventListener('click', () => {
        this.openSearch();
      });
    });

    closeSearchButton.addEventListener('click', () => {
      this.searchWrapper.classList.remove('-open');
      this.searchWrapper.classList.add('-is-closing');
    });

    this.searchWrapper.addEventListener('animationend', (e) => {
      if (e.animationName === 'fade-out') {
        this.closeSearch();
      }
    });

    this.searchInput.addEventListener('input', () => {
      if (this.searchInput.value !== '') {
        this.searchGoIcon.classList.add('-hidden');
        this.searchClearButton.classList.remove('-hidden');
      } else {
        this.searchGoIcon.classList.remove('-hidden');
        this.searchClearButton.classList.add('-hidden');
      }
    });

    // if (window.innerWidth < 764) {
    //   this.searchInput.addEventListener('focus', () => {
    //     searchForm.style.marginBottom = '20%';
    //   });

    //   this.searchInput.addEventListener('blur', () => {
    //     searchForm.style.marginBottom = '0%';
    //   });
    // }

    window.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        runSearch();
        e.preventDefault();
      }
    });

    this.searchClearButton.addEventListener('click', (e) => {
      e.preventDefault();
      this.searchInput.value = '';
      this.searchGoIcon.classList.remove('-hidden');
      this.searchClearButton.classList.add('-hidden');
      this.searchInput.focus();
    });

    searchCancelButton.addEventListener('click', (e) => {
      e.preventDefault();
      this.closeSearch();
    });

    // this.searchInput.addEventListener('focus', () => {
    //   if (this.searchInput.value !== '') {
    //     clearSearchButton.classList.remove('-hidden');
    //     cancelSearchButton.classList.add('-hidden');
    //   }
    // });

    // this.searchInput.addEventListener('focusout', () => {
    //   if (window.innerWidth >= 1208) {
    //     setTimeout(() => {
    //       clearSearchButton.classList.add('-hidden');
    //     }, 100);
    //   }
    // });

    searchForm.addEventListener('submit', (e) => {
      e.preventDefault();
      runSearch();
    });
  }

  setupPopperPlugin() {
    this.hideOnPopperBlur = {
      name: 'hideOnPopperBlur',
      defaultValue: true,
      fn(instance) {
        return {
          onCreate() {
            instance.popper.addEventListener('focusout', (event) => {
              if (
                instance.props.hideOnPopperBlur
                  && event.relatedTarget
                  && !instance.popper.contains(event.relatedTarget)
              ) {
                instance.hide();
              }
            });
          },
        };
      },
    };
  }

  setupLanguageSwitcher() {
    const languageSwitchers = this.menu.querySelectorAll('.language-switcher');
    if (!languageSwitchers) { return; }
    [...languageSwitchers].forEach((languageSwitcher) => {
      const switcherButton = languageSwitcher.querySelector('.switcher-button');
      const languages = languageSwitcher.querySelector('.languages');
      languages.style.minWidth = `${switcherButton.offsetWidth}px`;
      const languageButtons = languages.querySelectorAll('button');
      [...languageButtons].forEach((button) => {
        button.addEventListener('click', () => {
          window.location.href = button.dataset.url;
        });
      });

      tippy(switcherButton, {
        content: languages,
        offset: [0, 4],
        allowHTML: true,
        trigger: 'click',
        appendTo: 'parent',
        interactive: 'true',
        placement: 'bottom-start',
        plugins: [this.hideOnPopperBlur],

        render(instance) {
          const popper = document.createElement('div');
          popper.appendChild(instance.props.content);
          return { popper };
        },
      });
    });
  }

  enableBodyScroll() {
    document.body.classList.remove('-scroll-lock');
  }

  disableBodyScroll() {
    document.body.classList.add('-scroll-lock');
  }
}

domReady(() => {
  Menu.init();
});
